import { BasicCommand } from "./BasicCommand";


import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicErrorConstants } from "./constants/BasicErrorConstants";
import { BasicModel } from "../../model/BasicModel";

/**
 * Get forum login data command gets invoked automatically after the login by the game server.
 * Therefore there it won't be requested explicitly.
 *
 * Documentation:
 * https://sites.google.com/a/goodgamestudios.com/tech-wiki/java/gamedocumentation/core/events/sendforumlogindata
 */
export class GFLCommand extends BasicCommand {
    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_GET_FORUM_LOGIN_DATA;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == BasicErrorConstants.ALL_OK) {
            // Store forum key
            BasicModel.forumData.updateCryptedForumHash(String(params[1]));
            return true;
        }
        return false;
    }
}
